import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';

import { CreateCustomerApprovalWebConsoleCommand } from '../model/command/create-customer-approval-web-console-command';
import { CreateCustomerCommand } from '../model/command/create-customer-command';
import { EditCustomerCommand } from '../model/command/edit-customer-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for sending Customer commands to the API.
@Injectable()
export class CustomerCommandService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) { }

  CreateCustomerApprovalWebConsoleCommand(commandData: CreateCustomerApprovalWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Customer.CreateCustomerApprovalWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateCustomerCommand(commandData: CreateCustomerCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Customer.CreateCustomerCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditCustomerCommand(commandData: EditCustomerCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Customer.EditCustomerCommand'
      },
    };
    return this.http.request('POST', url, options);
  }
}
